import React from 'react';
import { Dialog } from '@material-ui/core';
import { SlideTransition } from './Transitions';

interface EditScreenLayoutProps {
    isOpened: boolean;
}

const FullScreenDialog: React.FC<EditScreenLayoutProps> = (
    { children, isOpened }
) => (
    <Dialog fullScreen open={isOpened} TransitionComponent={SlideTransition}>
        {isOpened ? children : null}
    </Dialog>
);

export default FullScreenDialog;
